<span class="p-float-label always-expanded">
  <p-datepicker
    [name]="name"
    [(ngModel)]="dateValue"
    (blur)="onBlur()"
    [showIcon]="true"
    [showOnFocus]="false"
    showTransitionOptions="0s"
    hideTransitionOptions="0s"
    [placeholder]="placeholder"
    panelStyleClass="sds"
    [disabled]="disabled"
    [showTime]="showTime"
    hourFormat="24"
    [appendTo]="appendTo"
  ></p-datepicker>
  <label class="{{ disabled ? 'label-disabled' : '' }}">{{ label }}</label>
</span>
